import {SaleVehiclePhotoType} from '@dms/api/settings';

import {PHOTO_GUIDE_SLOT_DND_ID_PREFIX} from '../constants/PHOTO_GUIDE_SLOT_DND_ID_PREFIX';

/** The dnd item id of an empty slot; a photo's id is used when the slot is filled. */
export const buildPhotoGuideSlotDndId = (photoType: SaleVehiclePhotoType) =>
  `${PHOTO_GUIDE_SLOT_DND_ID_PREFIX}${photoType}`;
